export default __webpack_public_path__ + "static/media/111.49bf7b3a.JPG";